"use strict";

var moment = require('moment');

module.exports = function (accumulator) {
  var date = moment().format('MMDDYY');

  if (accumulator) {
    return accumulator + '-' + date;
  }

  return date;
};